import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import Navbar from "../../components/Navbar";
import FeatureHighlight from "../../components/cultivars/FeatureHighlight";
import Footer from "../../components/Footer";
import ProductShowcase from "../../components/cultivars/Cadillacrainbows/ProductShowcase";
import CultivarDisplay from "../../components/cultivars/CultivarDisplay";
import Cta from "../../components/Cta";

const Cadillacrainbows = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Cadillac Rainbows Cultivar - BeyondBloom™</title>
        <meta name="description" content="Explore Cadillac Rainbows, a premium cultivar from BeyondBloom™. Experience vibrant flavors, potent effects, and high-quality genetics." />
        <meta name="keywords" content="Cadillac Rainbows, cannabis, premium cultivar, BeyondBloom, strains, top-quality plants, greenhouse" />
        <meta name="author" content="BeyondBloom™" />
        
        {/* Open Graph (Facebook & LinkedIn) */}
        <meta property="og:title" content="Cadillac Rainbows Cultivar - BeyondBloom™" />
        <meta property="og:description" content="Explore Cadillac Rainbows, a premium cultivar from BeyondBloom™. Experience vibrant flavors, potent effects, and high-quality genetics." />
        <meta property="og:image" content="/images/cadillac-rainbows.png" />
        <meta property="og:url" content="https://yourwebsite.com/cadillac-rainbows" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Cadillac Rainbows Cultivar - BeyondBloom™" />
        <meta name="twitter:description" content="Explore Cadillac Rainbows, a premium cultivar from BeyondBloom™. Experience vibrant flavors, potent effects, and high-quality genetics." />
        <meta name="twitter:image" content="/images/cadillac-rainbows.png" />
      </Helmet>

      <Navbar />
      <ProductShowcase />
      <FeatureHighlight />
      <CultivarDisplay />
      <Cta />
      <Footer />
    </>
  );
};

export default Cadillacrainbows;
